export default __webpack_public_path__ + "static/data-vis-color-role-do-089d00f29e41b6c8494a926f3a3aac5cf90746e58412ad645669c7da3e77d2e9.png";